enum TransactionStatus {
  Successful = 'Successful',
  Pending = 'Pending',
  Failed = 'Failed',
}

export default TransactionStatus;
